import React from 'react';
import Phone from './Phone';
import Email from './Email';

export const ErrorSave = () => {
  return (
    <>
      <div className="alert alert-danger">
        <p>
          <strong>There was an error saving your information.</strong>
        </p>

        <p>
          Please check your network connection and try again. If the problem
          persists, please contact us at <Phone /> or <Email />
        </p>
      </div>
    </>
  );
};

export default ErrorSave;
